import { EventBus } from '@/common/utils/event-bus'
import { MODAL_STANDARD } from '@/common/resources/const'

export const modalManager = () => {
  const closeLayerPopup = () => {
    EventBus.$emit(MODAL_STANDARD, { isOpen: false })
  }

  const openModal = {
    promotion: (args = {}) => {
      EventBus.$emit(MODAL_STANDARD, { isOpen: true, ...args })
    },
    standard: (args = {}) => {
      EventBus.$emit(MODAL_STANDARD, { isOpen: true, ...args })
    },
  }

  /**
   * eventName 을 받아 handler 가 있을 경우 handler 로직 처리 후 결과 값을 resolve
   * modal 에서 confirm 이후 처리되는 비동기 로직
   * resolve(true) | resolve(false) 를 반환
   * @param eventName
   * @param handler
   * @returns {Promise<unknown> | Promise}
   */
  const waitForEvent = (eventName, handler = (v) => v) => {
    return new Promise((resolve) => {
      EventBus.$once(eventName, (payload) => {
        const result = handler ? handler(payload) : payload

        resolve(result)
      })
    })
  }

  return {
    openModal,
    closeLayerPopup,
    waitForEvent,
  }
}
